import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import {
  InputText,
  TableData,
  TableRow,
  TableSecondary,
  Text,
} from "@pentabd/ui";

import { useLanguage } from "@hooks/useLanguage";
import {
  UPDATE_LEAVE,
  UpdateLeaveFormValidationDataType,
} from "@validations/HRM/leave/updateLeaveFormValidation";

import { LeaveType } from "@type/HRM/leave-type";

interface UpdateLeaveBalanceTableType {
  data: LeaveType[];
}

export const UpdateLeaveBalanceTable = ({
  data,
}: UpdateLeaveBalanceTableType) => {
  const { t } = useTranslation();
  const { language } = useLanguage();

  const {
    register,
    watch,
    formState: { errors },
  } = useFormContext<UpdateLeaveFormValidationDataType>();

  return (
    <TableSecondary
      columns={[
        {
          id: 1,
          name: t("LEAVE_UPDATE.TABLE.COLUMN.LEAVE_TYPE"),
        },
        {
          id: 2,
          name: t("LEAVE_UPDATE.TABLE.COLUMN.TOTAL_LEAVE"),
        },
        {
          id: 3,
          name: t("LEAVE_UPDATE.TABLE.COLUMN.TAKEN_LEAVE"),
        },
        {
          id: 4,
          name: t("LEAVE_UPDATE.TABLE.COLUMN.AVAILABLE_LEAVE"),
        },
      ]}
    >
      {data.map(({ nameEn, nameBn }: LeaveType, index: number) => {
        const totalLeaveCount = watch(
          `updateLeaveFormValidation.${index}.${UPDATE_LEAVE.TOTAL_LEAVE}`
        );
        const takenLeaveCount = watch(
          `updateLeaveFormValidation.${index}.${UPDATE_LEAVE.TAKEN_LEAVE}`
        );
        const availableLeave =
          Number(totalLeaveCount) - Number(takenLeaveCount);

        return (
          <TableRow key={index}>
            <TableData>
              <Text color="subtitle1">
                {language === "bn" ? nameBn : nameEn}
              </Text>
            </TableData>
            <TableData>
              <InputText
                {...register(
                  `updateLeaveFormValidation.${index}.${UPDATE_LEAVE.TOTAL_LEAVE}`
                )}
                placeholder="Total Leave"
                error={errors as any}
                controlling
              />
            </TableData>
            <TableData>
              <InputText
                {...register(
                  `updateLeaveFormValidation.${index}.${UPDATE_LEAVE.TAKEN_LEAVE}`
                )}
                placeholder="Taken Leave"
                error={errors as any}
                controlling
              />
            </TableData>
            <TableData>
              <Text color="subtitle1">{availableLeave}</Text>
            </TableData>
          </TableRow>
        );
      })}
    </TableSecondary>
  );
};
